<template>
    <LRLayout>
        <LeftPanel>
            <div class="searchType-content block-table-heder">
                <span v-text-lbl="'byClassification'" class="title" :class="searchType === '0' ? 'active' : ''" @click="searchType = '0'">按分类</span>
                <span v-text-lbl="'byTime'" class="title" :class="searchType === '1' ? 'active' : ''" @click="searchType = '1'">按时间</span>
                <span v-text-lbl="'byRecordType'" class="title" :class="searchType === '2' ? 'active' : ''" @click="searchType = '2'">按文种</span>
            </div>
            <GiantTree :nodes="treeData" @onCreated="onTreeCreated" @onClick="onTreeNodeClick" @onExpand="treeBeforeExpand" />
        </LeftPanel>
        <RightPanel>
            <FileList v-if="treeNode != null" :edit-permission="editPermission" :tree-node="treeNode" :search-type="searchType" :language="language" :map-list="mapList" :gdflsz-vos="gdflszVos" />
        </RightPanel>
    </LRLayout>
</template>

<script>
import FileList from './components/FileList'

export default {
    components: {
        FileList
    },
    props: {},
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'gdgl',
            treeData: [],
            treeNode: null,
            searchType: '0', // 搜索条件
            loginUser: this.$store.getters.loginUser,
            root: {
                file: [
                    { id: '0', parentId: '0', name: '所有文件', categoryName: '所有文件', open: true, title: '所有文件' }
                    // { id: '1', parentId: '0', name: '未分类文件', categoryName: '未分类文件', open: true, title: '未分类文件' }
                ],
                time: [{ id: '0', name: '所有文件', year: '所有文件', open: true, title: '所有文件' }],
                type: [{ id: '0', name: '所有文件', categoryName: '所有文件', open: true, title: '所有文件' }]
            },
            zTree: null,
            editPermission: false, // 设置权限
            language: []
        }
    },
    computed: {},
    watch: {
        searchType(val) {
            this.getTreeList()
        }
    },
    created() {
        // 判断页面是否可编辑
        const rolesList = this.$store.state.user.roles || []
        if (rolesList.some((v) => ['dwAdministrators', 'dwLeaders'].includes(v))) {
            this.editPermission = true
        }
        if (this.$route.meta.params && this.$route.meta.params.indexOf('searchType1') > -1) {
            this.searchType = '1'
        } else if (this.$route.meta.params && this.$route.meta.params.indexOf('searchType2') > -1) {
            this.searchType = '2'
        }
        this.getTreeList()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        onTreeCreated(zTree) {
            this.zTree = zTree
            const treeObj = this.zTree // 获取树
            const treenodes = treeObj.getNodes() // 人员所在机构的树节点
            if (treenodes.length > 0) {
                this.$nextTick(() => {
                    this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 获取节点数据
                    treeObj.selectNode(treenodes[0]) // 选中当前节点
                })
            }
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            console.log(treeNode, 'treeNode')
            this.treeNode = treeNode
        },
        getTreeList() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {},
                data: [],
                url: '/gwgl/gdwj/classificationQueryCollection'
            }).then((res) => {
                if (res.code === 'success') {
                    this.language = res.body.language
                    this.gdflszVos = res.body.gdflszVos
                    this.mapList = res.body.mapList
                    if (this.searchType === '0') {
                        this.treeData = this.treeDataAdapter(this.root.file.concat(res.body.gdflszVos))
                    } else if (this.searchType === '1') {
                        this.treeData = this.treeDataAdapter(this.root.time.concat(res.body.mapList))
                    } else if (this.searchType === '2') {
                        res.body.language.forEach((item) => {
                            item.id = ''
                            item.parentId = ''
                        })
                        this.treeData = this.treeDataAdapter(this.root.type.concat(res.body.language))
                    }
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (node.parentId === null || node.parentId === '' || node.parentId === undefined) {
                    node.pId = '0'
                } else {
                    node.pId = node.parentId
                }
                if (this.searchType === '0') {
                    node.name = node.categoryName
                    node.title = node.categoryName
                } else if (this.searchType === '1') {
                    node.title = node.year
                    node.name = node.year
                } else if (this.searchType === '2') {
                    node.title = node.name
                }
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        }
    }
}
</script>

<style scoped lang="scss">
.searchType-content {
    height: 36px;
    font-size: 0;
    text-align: center;
    .title {
        display: inline-block;
        font-size: 14px;
        line-height: 34px;
        padding: 0 15px;
        cursor: pointer;
        &.active {
            color: #409eff;
            border-bottom: 2px solid #409eff;
        }
    }
}

.ztree-container {
    height: calc(100vh - 208px);
}
.client-a {
    min-width: 1000px;
    padding: 32px 32px 16px 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.client-b {
    width: calc((100% - 32px) / 3);
    border: 1px solid #999;
    margin-bottom: 16px;
}
// .client-b:nth-of-type(3n){
//     margin-right: 0px;
// }
</style>
